import { cart } from "$lib/state/cart";
import { cartTotals } from "$lib/state/cartTotals";
import { ADD_TO_CART_EVENT, dispatchCustomEvent } from "./events";


export function setAllItemsInToCart(){
    let productOffer = localStorage?.getItem("productInOffer");
    let productCart = localStorage?.getItem('productCart');
    if(productCart){
      setOfferToCart(JSON.parse(productCart));
    }
    if(!productOffer)return
    let productObj = JSON.parse(productOffer);
    productObj.map(/**@param {string}sku*/(sku) =>setOfferToCart(sku));
   
  }
  /**@param {string}sku */
async function setOfferToCart(sku) {
    const formData = new FormData();
    formData.append("sku", sku);
    try {
      const setToCartStream = await fetch("/cart", {
        method: "POST",
        body: formData,
      });
      
      /** @type {import('$lib/types').CartResponse} */
      const response = await setToCartStream.json();

      if (setToCartStream.status === 200) {
        dispatchCustomEvent(
          ADD_TO_CART_EVENT,
          response.cart,
          sku,
          1
        );
        
        cart.set(response.cart);
        cartTotals.set(response.cartTotals);
      }

      if(setToCartStream.status === 200){
        localStorage.removeItem('productInOffer');
        localStorage?.removeItem('productCart');
      }
    } catch (error) {
      console.log(error);
    }
  }